<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "@/components/widgets/profile";
import Earning from "@/components/widgets/earning";
import Stat from "@/components/widgets/stat";
import Transaction from "@/components/widgets/transaction";
import Emailsent from "@/components/widgets/emailsent";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {

  },
  data() {
    return {
      title: "Checkout",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Default",
          active: true
        }
      ],
      data : [
        {
          picked: null
        }
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  <nav class="navbar navbar-expand-lg navigation sticky" id="navbar">
    <div class="container">
      <a class="navbar-logo" href="/">
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-dark" />
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-light" />
      </a>
    </div>
  </nav>

    <div class="row">
      <div class="col-xl-8">
        <div class="vertical-nav">
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div role="tablist">
                  <b-card no-body class="custom-accordion shadow-none mb-3">

                    <b-collapse
                      id="accordion-1"
                      visible
                      accordion="my-accordion"
                      role="tabpanel"
                    >
                      <b-card-body>
                        <div class="col-md-8">
                          <div class="row">
                            <div class="col">
                              <input type="radio" name="one" id="one" value="true" class="mr-2" v-model="picked">
                            </div>
                            <div class="col">
                              <label for=" one"><p><b>Semester</b><span> (Lebih hemat 20.000/1 Bulan)</span></p></label><br>
                            </div>
                          </div>
                        <input type="radio" name="two" id="two" value="false" class="mr-2" v-model="picked">
                        <label for=" two"><p><b>Tahun</b><span> (Lebih hemat 40.000/2 Bulan)</span></p></label>

                        
                        <p class="card-title mb-4">Metode Pembayaran</p>
                        <input type="radio" id="one" value="One" class="ml-2 mr-2" v-model="picked">
                        <label for="one"><img src="@/assets/images/transfer.png" alt="" width="35px" height="25px" class="mr-2">Transfer Bank</label>
                        </div>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>
              </div>
            </div>
          </b-card-text>
        </div>
      </div>
      <!-- end col -->

      <div class="col-xl-4">
        <div class="card">
          <div class="row">
            <div class="col-md-7">              
              <h5 class="mt-4 ml-4" style="color:#373334">DOMBA</h5>
            </div>
            <div class="col-sm-4" style="text-align:right">
              <p class="mt-4" style="color:#c6c6c6">Rp 300.000</p>
            </div>
          </div>
          <div class="card-body">
            
            <div style="text-align:right">
              <hr>
              <p style="color:#373334">Subtotal</p> 
              <h5 style="color:#00AFEF;"><b>Rp 300.000</b></h5>
            </div>
            <div class="text-center">
              <b-button class="center-text" variant="primary rounded-pill" style="background-color:#12c45f; border-style:none; width:280px;">Bayar</b-button> 
            </div>
          </div>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>